import * as React from 'react';
import { ReportInstitutionView } from 'cb-model';
import {
  PageTitle,
  PaginatorAndListSettings,
  Search,
  Section,
  useCacheQuery,
  useCloneEntity,
  useQueryOptionsFromSearchParams,
} from 'gossamer-front-end';
import { ReportMenu } from './ReportMenu';
import { useSetMaxWeekCommencing } from './useSetMaxWeekCommencing';

export const InstitutionWeekSearch = (): React.JSX.Element => {
  const [queryOptions, setQueryOptions] = useQueryOptionsFromSearchParams(ReportInstitutionView);
  useSetMaxWeekCommencing(queryOptions, setQueryOptions);
  const LocalReportInstitutionView = useCloneEntity(ReportInstitutionView, (clone) => {
    clone.fields.institution_id.listColumn = true;
    clone.fields.week_commencing.listColumn = true;
  });
  const gCacheQueryItem = useCacheQuery(ReportInstitutionView, queryOptions);
  return (
    <>
      <PageTitle title="Summary / Week Report" />
      <ReportMenu />
      <Section>
        <p>Events, Bookings and Attendance per Week</p>
        <PaginatorAndListSettings
          entity={LocalReportInstitutionView}
          gCacheQuery={gCacheQueryItem}
          queryOptions={queryOptions}
          render={Search}
          setQueryOptions={setQueryOptions}
        />
      </Section>
    </>
  );
};
